import React from 'react';
import styles from './InvoiceList.module.css';
import { formatCurrency, formatDate, formatMonthYear, groupInvoicesByCreatedAt } from '../utils';

const SearchIcon = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <circle cx="6.5" cy="6.5" r="5" stroke="#B9AFA8" strokeWidth="1.5" />
    <path d="M11 11L14.5 14.5" stroke="#B9AFA8" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const invoiceKey = inv => `${inv.placeId}_${inv.audit.createdAt}`;

const InvoiceList = ({ invoices, selectedInvoice, search, onSearchChange, onSelectInvoice }) => {
  const grouped = groupInvoicesByCreatedAt(invoices);

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <div className={styles.headerLabel}>Invoice History</div>
        <div className={styles.searchBar}>
          <SearchIcon />
          <input
            className={styles.searchInput}
            placeholder="Search by date…"
            value={search}
            onChange={e => onSearchChange(e.target.value)}
            autoComplete="off"
          />
          {search && (
            <button className={styles.clearBtn} onClick={() => onSearchChange('')}>
              ✕
            </button>
          )}
        </div>
        <div className={styles.count}>
          {invoices.length} invoice{invoices.length !== 1 ? 's' : ''}
        </div>
      </div>

      <div className={styles.scroll}>
        {invoices.length === 0 ? (
          <div className={styles.empty}>
            <div className={styles.emptyIcon}>🔍</div>
            <div className={styles.emptyTitle}>No invoices match</div>
            <div className={styles.emptySub}>"{search}"</div>
          </div>
        ) : (
          grouped.map(([month, invs]) => (
            <div key={month}>
              <div className={styles.monthHeader}>
                {month} · {invs.length}
              </div>
              {invs.map(inv => {
                const key = invoiceKey(inv);
                const selectedKey = selectedInvoice ? invoiceKey(selectedInvoice) : null;
                const isSelected = key === selectedKey;
                return (
                  <div
                    key={key}
                    className={`${styles.row} ${isSelected ? styles.selected : ''}`}
                    onClick={() => onSelectInvoice(inv)}
                  >
                    <div>
                      <div className={styles.invNum}>{formatMonthYear(inv.audit.createdAt)}</div>
                      <div className={`${styles.invPeriod} ${isSelected ? styles.invPeriodActive : ''}`}>
                        {inv.name}
                      </div>
                      <div className={styles.invPayDate}>📅 {formatDate(inv.audit.createdAt)}</div>
                    </div>
                    <div className={styles.rowRight}>
                      <div className={styles.rowAmount}>{formatCurrency(inv.netPayout)}</div>
                      <div className={styles.rowOrders}>{inv.orderCount} orders</div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default InvoiceList;
